/**
 * Classic mini-basket fragment refresh bridge.
 */
export function refreshCartFragments(cart) {
	document.dispatchEvent(
		new CustomEvent('bcQuickBuy:cartUpdated', {
			detail: { cart },
			bubbles: true,
		})
	);

	if (window.jQuery) {
		const $ = window.jQuery;
		$(document.body).trigger('wc_fragment_refresh');
		$(document.body).trigger('added_to_cart', [null, null, null]);
	}
}
